import axios from 'axios';

// Create and export the API client
export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || '/api',
  withCredentials: true,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Store the current token (updated from React via AuthTokenBootstrapper)
let getTokenFunction: (() => Promise<string | null>) | null = null;
export const setTokenGetter = (
  tokenGetter: (() => Promise<string | null>) | null,
): void => {
  getTokenFunction = tokenGetter;
};

// Add request interceptor to include Authorization header
apiClient.interceptors.request.use(
  async (config) => {
    if (
      config.url &&
      !config.url.startsWith('/') &&
      !config.url.startsWith('http')
    ) {
      config.url = `/${config.url}`;
    }
    if (getTokenFunction) {
      try {
        const freshToken = await getTokenFunction();
        console.log('Fresh token obtained:', freshToken ? '✓' : '✗');
        if (freshToken) {
          config.headers = config.headers || {};
          config.headers.Authorization = `Bearer ${freshToken}`;
        } else {
          console.warn('No token received from Clerk');
        }
      } catch (error) {
        console.error('Failed to fetch fresh token:', error);
        // Continue with request without token - let backend handle unauthorized
      }
    } else {
      console.warn('No token getter function set');
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// Optional: response interceptor just for logging or handling other errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error);
    return Promise.reject(error);
  },
);

// API methods
export async function uploadDocument(formData: FormData) {
  return apiClient.post('/documents/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export async function listDocuments(params: {
  asset_id?: number;
  transaction_id?: number;
}) {
  return apiClient.get('/documents', { params });
}

export async function getDocumentDownloadUrl(id: number) {
  return apiClient.get(`/documents/${id}/download-url`);
}

export async function deleteDocument(id: number) {
  return apiClient.delete(`/documents/${id}`);
}

export async function updateDocumentTags(id: number, tags: string[]) {
  return apiClient.patch(`/documents/${id}/tags`, { tags });
}
